// @flow
import React, { Component } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import noop from '../../utils/noop';
import styles from './SeeMoreItems.module.scss';

type Props = {
    className: string,
    hideSeeLess: boolean,
    items: any[],
    linkClassName: string,
    onSeeLessItemsClick: Function,
    onSeeMoreItemsClick: Function,
    seeLessFormattedMessageId: string,
    seeMoreFormattedMessageId: string,
    showItemCount: number,
    showTotal: boolean,
};

type State = {
    seeMore: boolean,
};

export default class SeeMoreItems extends Component<Props, State> {
    static defaultProps = {
        className: '',
        hideSeeLess: false,
        linkClassName: '',
        onSeeLessItemsClick: noop,
        onSeeMoreItemsClick: noop,
        seeLessFormattedMessageId: 'search_see_less',
        seeMoreFormattedMessageId: 'search_see_all',
        showItemCount: 3,
        showTotal: false,
    };

    state = {
        seeMore: false,
    };

    shouldComponentUpdate = (nextProps: Props, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    componentDidUpdate(prevProps: Props) {
        if (prevProps.items.length !== this.props.items.length) {
            this.setState({ seeMore: false });
        }
    }

    onSeeLess = () => {
        this.changeSeeMore();
        this.props.onSeeLessItemsClick();
    };

    onSeeMore = () => {
        this.changeSeeMore();
        this.props.onSeeMoreItemsClick();
    };

    changeSeeMore = () => {
        const seeMore = !this.state.seeMore;
        this.setState({ seeMore });
    };

    render() {
        const { seeMore } = this.state;

        const {
            className,
            hideSeeLess,
            items,
            linkClassName,
            seeLessFormattedMessageId,
            seeMoreFormattedMessageId,
            showItemCount,
            showTotal,
        } = this.props;

        const slicedItems = seeMore ? items : items.slice(0, showItemCount);

        const linkClasses = classNames(styles.seemore, linkClassName);
        const showSeeMore = items.length > showItemCount && !seeMore;
        const showSeeLess = !showSeeMore && !hideSeeLess && items.length > showItemCount;
        return (
            <div className={className}>
                {slicedItems}
                {showSeeMore && (
                    <Link key="see-more" className={linkClasses} onClick={this.onSeeMore}>
                        <FormattedMessage id={seeMoreFormattedMessageId} />
                        {showTotal && <> ({items?.length})</>}
                    </Link>
                )}
                {showSeeLess && (
                    <Link key="see-less" className={linkClasses} onClick={this.onSeeMore}>
                        <FormattedMessage id={seeLessFormattedMessageId} />
                    </Link>
                )}
            </div>
        );
    }
}
